export type LegacyRefundHistoryRow = {
  id: string
  refundDate: string
  refundAmount: string
  method: string
  medium: string
  memo: string
  customerNo: string
  baby: string
  parent: string
  phone: string
  total: string
  advance: string
  interim: string
  balance: string
  delivery: string
}

// A-01 deliberately uses anonymized fixtures only. They are never sent to an API.
export const legacyRefundHistoryRows: LegacyRefundHistoryRow[] = [
  { id: 'mock-refund-01', refundDate: '2026-08-20', refundAmount: '-50,000', method: '직접입력', medium: '계좌이체', memo: 'Mock 환불 메모 01', customerNo: 'MOCK-R-0001', baby: 'Mock 대상 01', parent: 'Mock 보호자 01', phone: '010-0000-1001', total: '500,000', advance: '100,000', interim: '150,000', balance: '250,000', delivery: '0' },
  { id: 'mock-refund-02', refundDate: '2026-08-19', refundAmount: '-30,000', method: '직접입력', medium: '현금', memo: 'Mock 환불 메모 02', customerNo: 'MOCK-R-0002', baby: 'Mock 대상 02', parent: 'Mock 보호자 02', phone: '010-0000-1002', total: '300,000', advance: '50,000', interim: '100,000', balance: '150,000', delivery: '0' },
  { id: 'mock-refund-03', refundDate: '2026-08-18', refundAmount: '-20,000', method: '직접입력', medium: '카드', memo: 'Mock 환불 메모 03', customerNo: 'MOCK-R-0003', baby: 'Mock 대상 03', parent: 'Mock 보호자 03', phone: '010-0000-1003', total: '400,000', advance: '100,000', interim: '100,000', balance: '200,000', delivery: '10,000' },
]
